import { Component } from '@angular/core';
import {TelService} from '../../services/tel.service';
import {UserService} from '../../services/user.service';
import {ActivatedRoute, Router } from '@angular/router';
import {HostListener} from '@angular/core';

@HostListener('window:keydown', ['$event'])
@Component({
  host: {
    '(document:keydown)': 'keyDown($event)',
  },
  templateUrl: './tel.component.html',
  styleUrls: ['./tel.component.css']
})

export class TelComponent {
  domain = "";
  done = false;
   theUser: string;
  searchText: string;

  constructor(private activatedRoute: ActivatedRoute, private TelService: TelService, private userSVC: UserService, private router: Router){

  }

  ngOnInit() {
     this.theUser = this.userSVC.authUser.email;
     if (!this.theUser) {
       this.router.navigate(['']);
     }

    this.activatedRoute.queryParams.subscribe(params => {
        this.searchText = params['q'] || "";
      });
   }

  tel() {
    if (this.domain.length > 3) {
      this.TelService.tel(this.domain);
      this.done = true;
      //this.domain = "";
      this.sync(); 
    }
  }

  sync() {
    if (this.domain.length > 3) {
      this.TelService.syncAuto(this.domain);
      this.TelService.syncSearch(this.domain);
      //this.domain = "";
    }

  }

  keyDown(event: any) {
    switch (event.keyCode) {
      case 13:
        this.tel()
        event.preventDefault();
        break;
    }
    return;
  }

  cancel() {
    this.router.navigate(['/admin/account'], { queryParams: { q : this.searchText}});
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/tel/tel.component.ts